import { Controller } from "@hotwired/stimulus";

// A typeface picked for a theme turns that theme's preview to it at once:
// every pairing's variables are already on the page, so the pick is only
// an attribute on the board.
export default class extends Controller {
  static targets = ["preview"];

  choose({ target, params: { theme } }) {
    this.previewTargets
      .filter((preview) => preview.dataset.deckTheme === theme)
      .forEach((preview) => (preview.dataset.deckFonts = target.value));
  }
}
